import _ from './default.json';
import comparethemarket from './comparethemarket.json';

export const defaultLocale = '_';

export const languages:any = {
	_: _,
	comparethemarket: comparethemarket
}
